import { render, staticRenderFns } from "./password_login.vue?vue&type=template&id=2471dde0&scoped=true&"
import script from "./password_login.vue?vue&type=script&lang=js&"
export * from "./password_login.vue?vue&type=script&lang=js&"
import style0 from "./password_login.vue?vue&type=style&index=0&id=2471dde0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2471dde0",
  null
  
)

export default component.exports